module.exports = __webpack_public_path__ + "img/广金钱草.d1b11fd8.jpg";